export const joannaRoch = {
    'meta': {
        'title': 'Psychoterapeuta Joanna Roch • Centrum COLLIGO w Toruniu',
        'description': 'Psychoterapeuta uzależnień, pracujący z dziećmi i młodymi dorosłymi, pedagog specjalny, certyfikowany terapeuta TSR, posiadający wieloletnie doświadczenie.'
    },
    'url': {
        'address': '/torun/zespol/psychoterapeuta-joanna-roch/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/joanna-roch.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psychoterapeuta Joanna Roch'
        }
    }
}